import { AxiosInstance } from "axios";

export const getOne = async (instance: AxiosInstance) => {};

export const getMany = async (instance: AxiosInstance) => {};
